module.exports = {"540321100":"江达镇","540321101":"岗托镇","540321200":"卡贡乡","540321201":"岩比乡","540321202":"邓柯乡","540321203":"生达乡","540321204":"娘西乡","540321205":"字嘎乡","540321206":"青泥洞乡","540321207":"汪布顶乡","540321208":"德登乡","540321209":"同普乡","540321210":"波罗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540321.json
// module id = 2842
// module chunks = 0